import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { FieldWorkType } from '../../models/field-work-type.model';

@Injectable({
  providedIn: 'root',
})
export class FieldWorkTypeService {
  private readonly http = inject(HttpClient);

  getFieldWorkTypes(): Observable<FieldWorkType[]> {
    return this.http.get<FieldWorkType[]>(
      `${environment.apiUrl}/field-work-types`,
    );
  }
}
